var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { inject, computed } from "vue";
import locale from "../locale/en_US.js";
import { CONFIG_PROVIDER_LOCALE_INJECTION_KEY, CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY } from "./injectionKeys.js";
function useConfigProvider() {
  const localeRef = inject(CONFIG_PROVIDER_LOCALE_INJECTION_KEY, computed(() => locale)), teleportRenderDisabledRef = inject(CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY, computed(() => !1));
  return { locale: localeRef, teleportRenderDisabled: teleportRenderDisabledRef };
}
__name(useConfigProvider, "useConfigProvider");
export {
  useConfigProvider
};
//# sourceMappingURL=useConfigProvider.js.map
